import { PdlMonitoring } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/pdl/monitoring')({
  component: RouteComponent,
  staticData: {
    icon: 'Gauge',
    title: 'Monitoring',
  },
});

function RouteComponent() {
  return <PdlMonitoring />;
}
